import { bl_mrp_pick_pack_queue_RowClass } from "../../../../dbschema";
import { BaseContainerModel } from "../../../base-container.model";

export class MrpPickPackQueueContainerModel extends BaseContainerModel {
  bl_mrp_pick_pack_queue: bl_mrp_pick_pack_queue_RowClass = new bl_mrp_pick_pack_queue_RowClass();
}